var n=function(r){return r.EMAIL="email",r.PHONE="phone",r}({});export{n as RequestContactType};